import { render, staticRenderFns } from "./StaticBiggestSell.vue?vue&type=template&id=4e971bbe&scoped=true"
import script from "./StaticBiggestSell.vue?vue&type=script&lang=js"
export * from "./StaticBiggestSell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e971bbe",
  null
  
)

export default component.exports